import { VALUES } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";

export const Mission = () => {
  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative py-24 lg:py-32 bg-[var(--surface)] border-y border-[var(--border-c)] scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="DatAsia Publishing · Our Mission"
              title={
                <>
                  Scholarship in service
                  <br />
                  of a shared heritage
                </>
              }
            />
            <Reveal delay={0.14}>
              <p className="mt-6 font-sans text-base sm:text-lg leading-relaxed text-[var(--text-2)]">
                DatAsia supports historical, cultural and educational projects
                across Southeast Asia. We recognize that many ethnicities and
                nations form one diversified whole — and that access to history
                belongs to everyone.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-px bg-[var(--border-c)] rounded-lg overflow-hidden border border-[var(--border-c)]">
              {VALUES.map(([title, text], i) => (
                <Reveal key={title} delay={0.08 + i * 0.05}>
                  <div
                    data-testid="value-item"
                    className={`h-full bg-[var(--bg)] p-7 ${
                      i === VALUES.length - 1 && VALUES.length % 2 === 1
                        ? "sm:col-span-2"
                        : ""
                    }`}
                  >
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--gold)]">
                      0{i + 1}
                    </span>
                    <h3 className="mt-3 font-serif text-2xl text-[var(--text)]">
                      {title}
                    </h3>
                    <p className="mt-2 font-sans text-sm leading-relaxed text-[var(--text-2)]">
                      {text}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
